import useSWR from 'swr';

import {
  commendaAiConversationsKey,
  listCommendaAiConversations,
  type CommendaAiScope,
  type CommendaAiWorkspaceId,
} from './api';

/** The shared conversation list (navbar Recents, sidebar rail and the conversation header all read
 * it through this one SWR key, so an async-generated title lands everywhere at once). */
export function useCommendaAiConversations(
  companyId: CommendaAiWorkspaceId,
  isWorkspaceResolved: boolean,
  scope?: CommendaAiScope
) {
  const { data, isLoading, error, mutate } = useSWR(
    commendaAiConversationsKey(companyId, isWorkspaceResolved, scope),
    ([, workspaceId, listScope]) =>
      listCommendaAiConversations(workspaceId, listScope)
  );

  return { conversations: data, isLoading, error, mutate };
}
